module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.9f4933e.woff";